import { createSelector } from 'reselect';

import { AppState } from '../../../store/store';

const rootState = (state: AppState) => state;

export const requestingSelector = createSelector(
    rootState,
    state =>
        state.dashboard.requesting ||
        state.demands.requesting ||
        state.inquiries.requesting ||
        state.purchaseOrders.requesting ||
        state.salesOrders.requesting ||
        state.invoices.requesting
);

export const searchResultCountSelector = createSelector(rootState, state => ({
    demands: state.demands.flat.total,
    inquiries: state.inquiries.flat.total,
    purchaseOrders: state.purchaseOrders.flat.total,
    salesOrders: state.salesOrders.flat.total,
    invoices: state.invoices.flat.total,
}));
